export default __webpack_public_path__ + "static/caa_icon-0d3faf53c6ffe0bf9ce4fe0dacd350b4.png";